import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HKButtonDirective } from './hk-button.dirrective';
import { NgIf } from '@angular/common';

@Component({
  selector: 'hk-dialog-apply-cancel-buttons',
  template: `
    <button (click)="cancel.emit()" data-testid="dialog.cancel.button" hk-button-stroked *ngIf="!hideCancelButton">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      (click)="apply.next()"
      data-testid="dialog.apply.button"
      color="primary"
      hk-button-raised
      [disabled]="!isApplyPossible"
      *ngIf="!hideApplyButton"
    >
      {{ 'common.apply' | translate }}
    </button>
  `,
  host: { class: 'flex gap-2' },
  standalone: true,
  imports: [TranslateModule, HKButtonDirective, NgIf],
})
export class DialogApplyCancelButtonsComponent {
  @Input() isApplyPossible = true;
  @Input() hideCancelButton = false;
  @Input() hideApplyButton = false;
  @Output() apply = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
}
